<template>
  <div>
    <template v-if="!isEditing">
      <span @click="onClickEdit">
        {{ codigoInterno ? codigoInterno : 'Adicionar código' }}
      </span>
      <v-btn icon
             class="mb-1"
             :small="small"
             :disabled="disabled"
             @click="onClickEdit">
        <v-icon :size="iconSize">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <template v-else>
      <v-text-field
        autofocus
        dense
        hide-details
        maxlength="200"
        class="rounded-tag-small"
        v-on:keyup.enter="onClickSave"
        v-model="codigoInterno"
      >
        <template v-slot:append-outer>
          <v-btn icon
                 :small="small"
                 :loading="loading"
                 @click="onClickSave">
            <v-icon :size="iconSize">mdi-check</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </template>
  </div>
</template>

<script>
import FornecedorService from './fornecedor-produto-service';

export default {
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: [String, Number],
      default: '20',
    },
  },
  data() {
    return {
      codigoInterno: null,
      isEditing: false,
      loading: false,
    };
  },
  methods: {
    onClickSave() {
      if (!this.fornecedor.id) {
        this.isEditing = false;
        this.fornecedor.codigoInterno = this.codigoInterno;
        return;
      }
      this.saveCodigoInterno();
    },
    onClickEdit() {
      this.isEditing = true;
    },
    saveCodigoInterno() {
      this.loading = true;

      const payload = {
        id: this.fornecedor.id,
        codigoInterno: this.codigoInterno,
      };

      FornecedorService.saveCodigoInterno(payload)
        .then(() => {
          this.$emit('update');
          this.$toast('Código atualizado', { color: 'success' });
          this.isEditing = false;
        }).finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.codigoInterno = this.fornecedor.codigoInterno;
  },
};
</script>
